import { DragIcon } from '@hakimo-ui/hakimo/ui-elements';
import { Button } from '@hakimo-ui/shared/ui-base';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { ReactNode } from 'react';
import { DraggableHOC } from '../draggable-hoc/DraggableHOC';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  initialPosition?: { top: number; left: number };
}

export function DraggableFloatingModal({
  isOpen,
  onClose,
  title,
  children,
  initialPosition,
}: Props) {
  if (!isOpen) {
    return null;
  }

  const defaultPosition = {
    top: 100,
    left: Math.max(20, window.innerWidth - 420),
  };

  return (
    <DraggableHOC
      initialPosition={initialPosition || defaultPosition}
      requireDragHandle={true}
    >
      <div className="max-w-96 overflow-hidden">
        <div className="bg-onlight-bg-1 dark:bg-ondark-bg-1 overflow-hidden rounded-lg">
          <div className="flex items-center justify-between p-3">
            <div
              className="flex min-w-0 flex-1 cursor-grab items-center gap-2 active:cursor-grabbing"
              data-drag-handle="true"
            >
              <DragIcon className="fill-onlight-text-2 dark:fill-ondark-text-2 h-4 w-4 flex-shrink-0" />
              <div className="text-onlight-text-2 dark:text-ondark-text-2 truncate font-sans text-sm font-semibold">
                {title}
              </div>
            </div>
            <Button
              variant="icon"
              onClick={onClose}
              className="text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200"
              title={`Close ${title.toLowerCase()}`}
            >
              <XMarkIcon className="h-5 w-5" />
            </Button>
          </div>
          <div className="text-onlight-text-2 dark:text-ondark-text-2 overflow-hidden px-4 pb-4 text-sm">
            {children}
          </div>
        </div>
      </div>
    </DraggableHOC>
  );
}
